import { faCheck, faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';

import CheckIcon from '../../assets/images/icons/check.svg';
import CrossIcon from '../../assets/images/icons/cross.svg';
import '../../assets/stylesheets/components/event-status-indicator.scss';
import { EventStatus as EventStatusEnum } from '../../enums';
import { colorScheme } from '../../theme';

interface EventStatusIndicatorProps {
  status: EventStatusEnum | boolean | null;
}
// TODO: replace with new indicator component
export function EventStatusIndicator(props: EventStatusIndicatorProps) {
  const { status } = props;

  if (status === EventStatusEnum.approved || status === true) {
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip id="t">Approved</Tooltip>}>
        <CenteredIcon className="fa-check" icon={faCheck} title="Approved" style={{ color: colorScheme.approve }} aria-label="Approved" />
      </OverlayTrigger>
    );
  }
  if (status === EventStatusEnum.rejected || status === false) {
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip id="t">Rejected</Tooltip>}>
        <CenteredIcon className="fa-check" icon={faTimes} title="Rejected" style={{ color: colorScheme.reject }} aria-label="Rejected" />
      </OverlayTrigger>
    );
  }
  if (status === EventStatusEnum.approved_warning) {
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip id="t">Warned</Tooltip>}>
        <CenteredIcon icon={faExclamationTriangle} title="Warned" style={{ color: colorScheme.warning }} aria-label="Warned" />
      </OverlayTrigger>
    );
  }
  return null;
}

export function EventStatusIndicatorWithText(props: EventStatusIndicatorProps) {
  const { status } = props;
  let toolTipText: string;
  let iconElement: any;

  if (status === EventStatusEnum.approved || status === true) {
    toolTipText = 'Approved';
    iconElement = <img src={CheckIcon} className="hdn-event__status--icon" alt="✓" />;
  } else if (status === EventStatusEnum.rejected || status === false) {
    toolTipText = 'Rejected';
    iconElement = <img src={CrossIcon} className="hdn-event__status--icon" alt="✗" />;
  } else {
    toolTipText = 'Unreviewed';
    iconElement = <span className="hdn-event__status--icon">?</span>;
  }

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id="t">{toolTipText}</Tooltip>}>
      <div className="hdn-event__status">
        {iconElement}
        <span className="hdn-event__status--label"> Internal</span>
      </div>
    </OverlayTrigger>
  );
}

const CenteredIcon = styled(FontAwesomeIcon)`
  text-align: center;
  display: inline-block;
`;
